export default __webpack_public_path__ + "static/media/pick_up_required.3a7bbab9.svg";